// extracted by mini-css-extract-plugin
export default {"error-box-wrapper":"EFErrorPageContent_error-box-wrapper__2tBjd","error-table-cell":"EFErrorPageContent_error-table-cell__zjO2k","error-text":"EFErrorPageContent_error-text__NKiws"};